import { render, staticRenderFns } from "./company-customer.vue?vue&type=template&id=db0b4aca&scoped=true&"
import script from "./company-customer.vue?vue&type=script&lang=js&"
export * from "./company-customer.vue?vue&type=script&lang=js&"
import style0 from "./company-customer.vue?vue&type=style&index=0&id=db0b4aca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0b4aca",
  null
  
)

export default component.exports